module.exports = __webpack_public_path__ + "static/media/edit.9a42f494.svg";